import $ from 'jquery'

export class SliderLogo {

  constructor($container)
  {
			// this.$ = $container.find('.slider-logo-')
			// this.$has_intro = $container.find('.slider-logo-has-intro')
			// this.$intro = $container.find('.slider-logo-intro')
			// this.$ = $container.find('.slider-logo-')
			// this.$ = $container.find('.slider-logo-')
  }

}
